import React from 'react';
import PropTypes from 'prop-types';
import MessagePanel from './MessagePanel';//eslint-disable-line import/no-named-as-default
import * as appHelper from '../../helpers/appHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import ReactQuill from 'react-quill'; //https://github.com/zenoamaro/react-quill#quick-start
import ReactDOM from 'react-dom';
import * as keyboardConstants from '../../constants/keyboardConstants';



export class BasicEditor extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            inFocus: false,
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'align', {'align': 'center'}, {'align': 'right'}, {'list': 'ordered'}, {'list': 'bullet'}],

                ],
            },
            formats: [
                'align', 'bold', 'italic','underline', 'list', 'bullet', 'clean'
            ]
            /*modules: {
                toolbar: [
                    ['bold', 'italic'],
                    [{'list': 'ordered'}, {'list': 'bullet'}],
                    ['clean']
                ],
            },
            formats: [
                'bold', 'italic',
                'list', 'bullet'
            ]*/

        };
        this.getWrapperClass = this.getWrapperClass.bind(this);
        this.getFieldClass = this.getFieldClass.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.addFocusOutEffect = this.addFocusOutEffect.bind(this);
        this.onFocusOutComplete = this.onFocusOutComplete.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount(){

    }

    componentWillUnmount() {

    }

    handleClickOutside(event){
        if (appHelper.isDefined(ReactDOM.findDOMNode(this))){
            const domNode = ReactDOM.findDOMNode(this);

            if ((!domNode || !domNode.contains(event.target))) {
                this.onFocusOut();
            }
        }
    }

    getWrapperClass(){
        let wrapperClass = `form-group`;

        if(appHelper.isDefined(this.props.wrapperClassName)){
            wrapperClass += ` ${this.props.wrapperClassName}`;
        }

        if(this.state.inFocus){
            wrapperClass += ` active`;
        }

        if (this.props.error && this.props.error.length > 0) {
            wrapperClass += ` has-error`;
        }

        return wrapperClass;
    }

    getFieldClass(){
        let wrapperClass =`form-control ${this.props.className}`;


        if(this.state.inFocus){
            wrapperClass += ` active`;
        }

        return wrapperClass;
    }

    onFocusIn(){
        this.setState({
            inFocus: true
        });
    }

    onFocusOut(){
        this.setState({
            inFocus: false
        });
        this.addFocusOutEffect();
    }

    addFocusOutEffect(){
        let inputRef = this.refs[`input_${this.props.name}`];
        if(appHelper.isDefined(inputRef)) {
            inputRef.classList.remove("focus-out");
            TweenLite.to(inputRef, 0.5, {
                css: {className: '+=focus-out'}
            }).eventCallback("onComplete", this.onFocusOutComplete);
        }
    }

    onFocusOutComplete(){
        let inputRef = this.refs[`input_${this.props.name}`];
        if(appHelper.isDefined(inputRef)) {
            inputRef.classList.remove("focus-out");
        }
    }

    setKeyboardAccessibility(){

    }



    render() {
        return (
            <div className={`${this.getWrapperClass()}`}>
                <div className="relative-input-wrapper">
                    <label className="editor-label" htmlFor={this.props.name}>
                        <span dangerouslySetInnerHTML={{__html: this.props.label}} />



                        {typeof subLabel !== 'undefined'
                            ? <span className="sub-label"> - {this.props.subLabel}</span>
                            : null
                        }

                    </label>
                    <div ref={`input_${this.props.name}`}>
                        <ReactQuill
                            name={this.props.name}
                            id={this.props.name}
                            value={this.props.value}
                            onChange={this.props.onChange}
                            placeholder={appHelper.isDefined(this.props.placeholder) ? this.props.placeholder : `${appHelper.getLocaleString("text_editor_placeholder")}`}

                            onKeyPress={this.onFocusIn}
                            theme="snow"
                            modules={this.state.modules}
                            formats={this.state.formats}
                        />

                        {typeof this.props.messagePanelParams != 'undefined' && this.props.messagePanelParams.show
                            ?<MessagePanel name={this.props.name} message={this.props.messagePanelParams.message} alignment={this.props.messagePanelParams.alignment} show={this.props.messagePanelParams.show}/>
                            :null
                        }
                        {this.props.error && <div className="alert alert-danger">{this.props.error}</div>}
                    </div>
                </div>
            </div>
        );
    }
}

BasicEditor.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    subLabel: PropTypes.string,
    wrapperClassName: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    messagePanelParams: PropTypes.object,
    onDoneFocusId: PropTypes.string,
    index: PropTypes.number
};

//Pull in the React Router context so router is available on this.context.router.
BasicEditor.contextTypes = {
    router: PropTypes.object
};

//Init


export default BasicEditor;


/** WEBPACK FOOTER **
 ** ./src/components/form/BasicEditor.js
 **/